import { render, staticRenderFns } from "./RectangleCoordinateEditor.vue?vue&type=template&id=2adaa3ac&scoped=true&"
import script from "./RectangleCoordinateEditor.vue?vue&type=script&lang=ts&"
export * from "./RectangleCoordinateEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2adaa3ac",
  null
  
)

export default component.exports